export default __webpack_public_path__ + "static/media/Class-9-State-Math.aa9f1550.pdf";